import { Role, rolesManipulator, useGetUserRoleBusinessesIDs } from 'auth';
import { useCallback, useContext, useMemo } from 'react';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { useCurrentUserQuery } from '@/modules/auth/queries/user.tsx';
import BusinessModal from '@/modules/admin-dashboard/components/modals/BusinessModal.tsx';
import { DisclosureListItem, EmptyListState, ModalProviderContext, PageLayout, Spinner } from 'ui';
import { EditIcon } from 'ui/icons';
import { BusinessResponse } from 'compliance-api';

const Businesses = () => {
  const { data, isLoading } = useCurrentUserQuery();
  const availableRegistersIds = useGetUserRoleBusinessesIDs(rolesManipulator.current_user_role);
  const { openModal } = useContext(ModalProviderContext);

  const businesses = useMemo(
    () => (data?.businesses || []).filter(business => availableRegistersIds.includes(business.id)),
    [availableRegistersIds, data?.businesses],
  );

  const handleOpenBusinessModal = useCallback(
    (initBusiness: BusinessResponse) => {
      openModal(BusinessModal, { initBusiness });
    },
    [openModal],
  );
  return (
    <PageLayout title="Organisations">
      {isLoading && (
        <div className="w-full h-full flex justify-center items-center">
          <Spinner size="lg" />
        </div>
      )}
      {businesses.length && (
        <div className="space-y-3">
          {businesses.map(business => (
            <DisclosureListItem
              key={business.id}
              leftMainString={
                <div className="flex gap-3 items-center">
                  {business?.icon_url && (
                    <span className="bg-white border-white border">
                      <img
                        src={business?.icon_url}
                        alt="icon"
                        className="w-6 h-6 max-w-6 max-h-6"
                      />
                    </span>
                  )}
                  <span>{business?.name || ''}</span>
                </div>
              }
              rightContent={
                <button onClick={handleOpenBusinessModal.bind(null, business)}>
                  <img alt="edit" src={EditIcon} />
                </button>
              }
            />
          ))}
        </div>
      )}
      <EmptyListState
        title="There are no organisations"
        description="This displays the organisations in which you have an administrator role."
        isLoading={isLoading}
        itemsCount={businesses.length}
      />
    </PageLayout>
  );
};

export default withPrivateAccess(Businesses, Role.COMPLIANCE_ADMIN);
